import axios from '@/utils/request'

export default {
  getCouponsList: (data) => axios({ url: '/api/product/couponTicketList', method: 'POST', data }), // 后台-获取优惠券列表
  updateCouponStatus: (data) => axios({ url: '/api/product/couponTicketStatus', method: 'PUT', data }), // 后台-更新优惠券状态
  manuallyIssueCouponTickets: (data) => axios({ url: '/api/product/manuallyIssueCouponTickets', method: 'POST', data }), // 后台-手动发放优惠券
  getCustomerCouponsList: (data) => axios({ url: '/api/product/couponTicketCollectionFormList', method: 'POST', data }), // 后台-获取客户优惠券列表
  stopUseCoupon: (data) => axios({ url: '/api/product/voidCouponTicketCollectionForm', method: 'POST', data }), // 后台-停止（作废客户优惠券）
  setOrEditCoupon: (data) => axios({ url: '/api/product/editCouponTicket', method: 'POST', data }), // 后台-新增或编辑优惠券
  getCouponDetails: (params) => axios({ url: '/api/product/couponTicket', method: 'GET', params }), // 后台-获取优惠券详情
}
